import React, { useState } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { setLocale } from "../../actions/cartActions";
import LanguageTools from "../../utils/LanguageTools";

import { Box, DropButton } from "grommet";
import ReactCountryFlag from "react-country-flag";

const LanguageSelector = ({ i18n, match, location, locale, setLocale }) => {
  const [menuOpen, setMenuOpen] = useState({}); // Open voting

  const changeLanguage = (lng, dispatch) => {
    const currentLocale =
      i18n.language || window.localStorage.i18nextLng || "en-UK";
    if (lng !== currentLocale) {
      console.log("Language changed to " + lng + ", reloading page...");
      setTimeout(() => {
        window.location.reload();
      }, 500); // Reload to fetch new content from Contentful
    } else {
    }
    i18n.changeLanguage(lng);
    LanguageTools.setLanguageCookie(lng);
    if (dispatch) {
      dispatch(lng);
    }
  };

  const getFlagFromLocale = (locale) => {
    if (!locale) {
      return <ReactCountryFlag countryCode="US" />;
    }
    switch (locale.toLowerCase()) {
      case "en-eu":
        return <ReactCountryFlag countryCode="EU" />;
      case "en-uk":
        return <ReactCountryFlag countryCode="GB" />;
      case "en-us":
        return <ReactCountryFlag countryCode="US" />;
      case "en-ie":
        return <ReactCountryFlag countryCode="IE" />;
      case "de-de":
        return <ReactCountryFlag countryCode="DE" />;
      case "de-at":
        return <ReactCountryFlag countryCode="AT" />;
      case "fr-fr":
        return <ReactCountryFlag countryCode="FR" />;
      case "nl-nl":
        return <ReactCountryFlag countryCode="NL" />;
      case "it-it":
        return <ReactCountryFlag countryCode="IT" />;
      case "fr-be":
        return <ReactCountryFlag countryCode="BE" />;
      case "nl-be":
        return <ReactCountryFlag countryCode="BE" />;
      case "es-es":
        return <ReactCountryFlag countryCode="ES" />;
      case "pt-pt":
        return <ReactCountryFlag countryCode="PT" />;
      default:
        return <ReactCountryFlag countryCode="US" />;
    }
  };

  return (
    <div className="LanguageSelector">
      <DropButton
        className="LanguageSelectorButton"
        style={{ width: "120px" }}
        //label={locale}
        dropAlign={{ top: "bottom", right: "right" }}
        dropProps={{
          style: {
            zIndex: 105,
            width: "200px",
            borderRadius: "5px",
            marginBottom: "5px",
          },
        }}
        dropContent={
          <Box className="LanguageSelectorPopup" background="light-2">

            <Link to={LanguageTools.generateLanguage("en-uk", location)}>
              <button onClick={() => changeLanguage("en-uk", setLocale)}>
                <ReactCountryFlag countryCode="GB" />
                <b>UK</b>
              </button>
            </Link>

            <Link to={LanguageTools.generateLanguage("en-us", location)}>
              <button onClick={() => changeLanguage("en-us", setLocale)}>
                <ReactCountryFlag countryCode="US" />
                <b>USA</b>
              </button>
            </Link>

            <Link to={LanguageTools.generateLanguage("de-de", location)}>
              <button onClick={() => changeLanguage("de-de", setLocale)}>
                <ReactCountryFlag countryCode="DE" />
                <b>Deutschland</b>
              </button>
            </Link>

            <Link to={LanguageTools.generateLanguage("fr-fr", location)}>
              <button onClick={() => changeLanguage("fr-fr", setLocale)}>
                <ReactCountryFlag countryCode="FR" />
                <b>France</b>
              </button>
            </Link>

            <Link to={LanguageTools.generateLanguage("en-eu", location)}>
              <button onClick={() => changeLanguage("en-eu", setLocale)}>
                <ReactCountryFlag countryCode="EU" />
                <b>EU (En)</b>
              </button>
            </Link>

            <Link to={LanguageTools.generateLanguage("nl-nl", location)}>
              <button onClick={() => changeLanguage("nl-nl", setLocale)}>
                <ReactCountryFlag countryCode="nl" />
                <b>Nederland</b>
              </button>
            </Link>

            <Link to={LanguageTools.generateLanguage("it-it", location)}>
              <button onClick={() => changeLanguage("it-it", setLocale)}>
                <ReactCountryFlag countryCode="it" />
                <b>Italia</b>
              </button>
            </Link>

            <Link to={LanguageTools.generateLanguage("de-at", location)}>
              <button onClick={() => changeLanguage("de-at", setLocale)}>
                <ReactCountryFlag countryCode="at" />
                <b>Österreich</b>
              </button>
            </Link>

            <Link to={LanguageTools.generateLanguage("fr-be", location)}>
              <button onClick={() => changeLanguage("fr-be", setLocale)}>
                <ReactCountryFlag countryCode="be" />
                <b>Belgique (FR)</b>
              </button>
            </Link>

            <Link to={LanguageTools.generateLanguage("nl-be", location)}>
              <button onClick={() => changeLanguage("nl-be", setLocale)}>
                <ReactCountryFlag countryCode="be" />
                <b>België (NL)</b>
              </button>
            </Link>

            <Link to={LanguageTools.generateLanguage("en-ie", location)}>
              <button onClick={() => changeLanguage("en-ie", setLocale)}>
                <ReactCountryFlag countryCode="ie" />
                <b>Ireland</b>
              </button>
            </Link>

            <Link to={LanguageTools.generateLanguage("es-es", location)}>
              <button onClick={() => changeLanguage("es-es", setLocale)}>
                <ReactCountryFlag countryCode="es" />
                <b>España</b>
              </button>
            </Link>

            <Link to={LanguageTools.generateLanguage("pt-pt", location)}>
              <button onClick={() => changeLanguage("pt-pt", setLocale)}>
                <ReactCountryFlag countryCode="pt" />
                <b>Portugal</b>
              </button>
            </Link>
          </Box>
        }
      >
        {getFlagFromLocale(i18n.language)} {i18n.language}
      </DropButton>
    </div>
  );
};

// Map redux state to props (remember to export below with this function)
const mapStateToProps = (state) => {
  return {
    locale: state.cart.locale,
  };
};

// Map redux dispatches to props (remember to export below with this function)
const mapDispatchToProps = (dispatch) => {
  return {
    setLocale: (locale) => {
      dispatch(setLocale(locale));
    },
  };
};

//export default LanguageSelector
export default connect(mapStateToProps, mapDispatchToProps)(LanguageSelector);
